"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BusinessItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _react2 = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productListingContext = require("../product-listing-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* VENDOR */

/* LOCAL */

const Checkbox = /*#__PURE__*/(0, _react.styled)("label")({
  name: "Checkbox",
  class: "pl-c1gb7v83"
});

/**
 * Render Business Item.
 * @module BusinessItem
 *
 * @param {object} props React props
 * @param {string} props.id An unique identifier
 * @param {boolean} props.isActive Flag delineating active state
 * @param {string} props.label Business Type label
 * @returns {React.ReactElement} BusinessItem component
 * @public
 */
function BusinessItem({
  id,
  isActive,
  label,
  trackingCustomProperties = {}
}) {
  const {
    businesses,
    setBusinesses,
    setUserInteracted
  } = (0, _react2.useContext)(_productListingContext.ProductListingContext);
  const toggleBusiness = () => {
    setUserInteracted(true);
    const newBusinesses = businesses?.map(business => {
      if (business.businessName?.Text === label) {
        return {
          ...business,
          isActive: !business.isActive
        };
      }
      return business;
    });
    setBusinesses(newBusinesses);
  };
  return /*#__PURE__*/_react2.default.createElement("div", (0, _extends2.default)({
    id: id ? `id-${id}` : '',
    "data-cy": "business-item"
  }, _patternLibraryUtils.tracking.create(`business_${label}`, true, false, trackingCustomProperties)), /*#__PURE__*/_react2.default.createElement(Checkbox, null, /*#__PURE__*/_react2.default.createElement("input", {
    type: "checkbox",
    checked: isActive,
    onChange: toggleBusiness
  }), label));
}
BusinessItem.propTypes = {
  id: _propTypes.default.string,
  isActive: _propTypes.default.bool,
  label: _propTypes.default.string,
  trackingCustomProperties: _propTypes.default.object
};